export const ReturnIcon = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.5 12L19.5 12" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8.5 16L5.20711 12.7071C4.81658 12.3166 4.81658 11.6834 5.20711 11.2929L8.5 8" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
